import typography from 'theme/ui/typography'

export const HeadingVariant = {
  HeadingXXLSemiBold: 'heading-xxl-semibold',
  HeadingXXLRegular: 'heading-xxl-regular',
  HeadingXLSemiBold: 'heading-xl-semibold',
  HeadingXLRegular: 'heading-xl-regular',
  HeadingLGSemiBold: 'heading-lg-semibold',
  HeadingLGRegular: 'heading-lg-regular',
  HeadingMDSemiBold: 'heading-md-semibold',
  HeadingMDRegular: 'heading-md-regular',
  HeadingSMSemiBold: 'heading-sm-semibold',
  HeadingSMRegular: 'heading-sm-regular',
  HeadingXSSemiBold: 'heading-xs-semibold',
  HeadingXSRegular: 'heading-xs-regular',
} as const

export const TextVariant = {
  // ---------Display
  DisplayLG: 'display-lg', // in Figma: Display_LG
  Display: 'display',
  DisplaySM: 'display-sm',

  // ---------Heading
  ...HeadingVariant,

  // ---------Body
  BodyLGSemibold: 'body-lg-semibold',
  BodyLGRegular: 'body-lg-regular',
  BodySemiBold: 'body-semibold',
  BodyRegular: 'body-regular',
  BodySMSemiBold: 'body-sm-semibold',
  BodySMRegular: 'body-sm-regular',

  // ---------Label
  LabelLG: 'label-lg',
  Label: 'label',
  LabelSM: 'label-sm',
  LabelLGCap: 'label-lg-cap',
  LabelCap: 'label-cap',
  LabelSMCap: 'label-sm-cap',
} as const

export const TextVariantMap = {
  // ---------Display
  [TextVariant.DisplayLG]: {
    fontSize: typography.fontSizes.display_lg,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.display,
  },
  [TextVariant.Display]: {
    fontSize: typography.fontSizes.display,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.display,
  },
  [TextVariant.DisplaySM]: {
    fontSize: typography.fontSizes.display_sm,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.display,
  },

  // ---------Heading
  [TextVariant.HeadingXXLSemiBold]: {
    fontSize: typography.fontSizes.heading_xxl,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingXXLRegular]: {
    fontSize: typography.fontSizes.heading_xxl,
    fontWeight: typography.fontWeights.regular,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingXLSemiBold]: {
    fontSize: typography.fontSizes.heading_xl,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingXLRegular]: {
    fontSize: typography.fontSizes.heading_xl,
    fontWeight: typography.fontWeights.regular,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingLGSemiBold]: {
    fontSize: typography.fontSizes.heading_lg,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingLGRegular]: {
    fontSize: typography.fontSizes.heading_lg,
    fontWeight: typography.fontWeights.regular,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingMDSemiBold]: {
    fontSize: typography.fontSizes.heading_md,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingMDRegular]: {
    fontSize: typography.fontSizes.heading_md,
    fontWeight: typography.fontWeights.regular,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingSMSemiBold]: {
    fontSize: typography.fontSizes.heading_sm,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingSMRegular]: {
    fontSize: typography.fontSizes.heading_sm,
    fontWeight: typography.fontWeights.regular,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingXSSemiBold]: {
    fontSize: typography.fontSizes.heading_xs,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.heading,
  },
  [TextVariant.HeadingXSRegular]: {
    fontSize: typography.fontSizes.heading_xs,
    fontWeight: typography.fontWeights.regular,
    lineHeight: typography.lineHeights.heading,
  },

  // ---------Body
  [TextVariant.BodyLGSemibold]: {
    fontSize: typography.fontSizes.body_lg,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.body,
  },
  [TextVariant.BodyLGRegular]: {
    fontSize: typography.fontSizes.body_lg,
    fontWeight: typography.fontWeights.regular,
    lineHeight: typography.lineHeights.body,
  },
  [TextVariant.BodySemiBold]: {
    fontSize: typography.fontSizes.body,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.body,
  },
  [TextVariant.BodyRegular]: {
    fontSize: typography.fontSizes.body,
    fontWeight: typography.fontWeights.regular,
    lineHeight: typography.lineHeights.body,
  },
  [TextVariant.BodySMSemiBold]: {
    fontSize: typography.fontSizes.body_sm,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.body,
  },
  [TextVariant.BodySMRegular]: {
    fontSize: typography.fontSizes.body_sm,
    fontWeight: typography.fontWeights.regular,
    lineHeight: typography.lineHeights.body,
  },

  [TextVariant.LabelLG]: {
    fontSize: typography.fontSizes.label_lg,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.label,
  },
  [TextVariant.Label]: {
    fontSize: typography.fontSizes.label,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.label,
  },
  [TextVariant.LabelSM]: {
    fontSize: typography.fontSizes.label_sm,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.label,
  },
  [TextVariant.LabelLGCap]: {
    fontSize: typography.fontSizes.label_lg,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.label,
    textTransform: 'uppercase',
  },
  [TextVariant.LabelCap]: {
    fontSize: typography.fontSizes.label,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.label,
    textTransform: 'uppercase',
  },
  [TextVariant.LabelSMCap]: {
    fontSize: typography.fontSizes.label_sm,
    fontWeight: typography.fontWeights.semibold,
    lineHeight: typography.lineHeights.label,
    textTransform: 'uppercase',
  },
} as const

export type TextVariantType = (typeof TextVariant)[keyof typeof TextVariant]
export type HeadingVariantType = (typeof HeadingVariant)[keyof typeof HeadingVariant]
